// import node module libraries
import { Fragment } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// import sub components
import FooterHaeppyappWithLinks from './FooterHaeppyappWithLinks';

const FooterHaeppyapp = () => {
	return (
		<Fragment>
			<FooterHaeppyappWithLinks />
		</Fragment>
	);
};

export default FooterHaeppyapp;
